<div class="modal-header">
    <h5 class="modal-title">{{ data?.title || 'Information' }}</h5>
    <button type="button" class="close" (click)="onCancel()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <!-- Default Text Content -->
    <div *ngIf="type != 'FORM'" [innerHTML]="data?.content" class="modal-text-content"></div>
    
    <!-- Dynamic Form/Info View -->
    <info-view 
        *ngIf="type == 'FORM'" 
        [modifyData]="data?.modifyData || {}" 
        [mode]="mode" 
        [sourceData]="data?.sourceData" 
        [formData]="data?.formData"
    ></info-view>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-primary px-4" (click)="onCancel()">
        {{ data?.btn || 'OK' }}
    </button>
</div>